export const editPathName = (path) => ({ type: 'pathname', payload: path });
export const sidebarChange = (state) => ({ type: 'set', payload: state });
export const searchStr = (state) => ({ type: 'searchStr', payload: state });
